<template>
  <div>
    <new-maintainInfo showingPage="leave"></new-maintainInfo>
  </div>
</template>

<script>
import infoList from '../../../components/newspaperInfoListLeave.vue' 
/**
 *@ClassName:repoInfoList
 *@Description:报事信息
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-16
 */
export default {
  name: '/manage/main.newspaperInfoListLeave',
  components: {
    'new-maintainInfo': infoList 
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
  
},
}
</script>
<style lang='scss'>
 
</style>
